import React from 'react';
import Grid from '../Grid';
import Services from '../Services';
import Time from '../Time';
import Duration from '../Duration';
import Money from '../Money';
import UserName from '../UserName';
import Text from '../Text';
import InlineForecast from '../../Weather/InlineForecast';
import Address from '../Address';
import Icon from '../../Icons/Icon';
import { statuses } from '../../../Data/Jobs';
import Alert from '../../Alert';
import NoValue from '../../EmptyStates/NoValue';
import DateTime from '../DateTime';
import Badge from '../../Badge/Badge';
import Tags from '../../Tags/Tags';
import { useCustomer } from '../../../Data/Customers';
import { useSession } from '../../Session';

const JobDetails = ({job, customer, onChange}) => {
    const {removeTags, removeJobTags} = useCustomer(customer?.id);
    const {hasFeature} = useSession();

    if (!job) {
        return <Alert theme="danger"
            title="No job details"
            message="No job details were available. This might be because the job has been deleted."
        />
    }

    return <Grid className="text-left" items={[
        [
            <strong>Title</strong>,
            job.title,
            !!job.title
        ],
        [
            <strong>Customer Tags</strong>,
            <Tags tags={customer.tags}
                dismiss={async (tagId) => {
                    await removeTags([tagId])
                    onChange && await onChange();
                }}
            />,
            !!customer.tags?.length && hasFeature('TAGS')
        ],
        [
            <strong>Job Tags</strong>,
            <Tags tags={job.tags}
                dismiss={async (tagId) => {
                    await removeJobTags(job.id, [tagId])
                    onChange && await onChange();
                }}
            />,
            !!job.tags?.length && hasFeature('TAGS')
        ],
        [
            <strong>Address</strong>,
            <Address address={customer?.address ?? null} />,
        ],
        [
            <strong>Services</strong>,
            <Services services={job.services} />,
        ],
        [
            <strong>Status</strong>,
            <><Icon icon={statuses[job.status].icon} className={statuses[job.status].colors} size="1x" /> {job.status}</>,
        ],
        [
            <strong>Weather</strong>,
            <InlineForecast location={customer} date={job.scheduledDate} time={job.estimatedTime}/>,
        ],
        [
            <strong>Scheduled</strong>,
            <DateTime date={job.scheduledDate} hideTime />,
            !!job.scheduledDate,
        ],
        [
            <strong>ETA</strong>,
            <Time time={job.estimatedTime} />,
            !!job.estimatedTime,
        ],
        [
            <strong>Duration</strong>,
            job.duration ? <Duration time={job.duration} /> : <NoValue />,
            !!job.duration,
        ],
        [
            <strong>Assigned</strong>,
            <UserName userId={job.assignedTo} />,
            !!job.assignedTo,
        ],
        [
            <strong>Cost</strong>,
            <Money pence={job.cost} />,
        ],
        [
            <strong>Job notes</strong>,
            <Text text={job.notes} />,
            !!job.notes,
        ],
        [
            <strong>Customer notes</strong>,
            <Text text={customer?.notes ?? null} />,
            !!customer?.notes ?? null,
        ],
        [
            <strong>Balance</strong>,
            <Money pence={customer?.balance ?? null} colour />,
        ],
        [
            <strong>Notifications</strong>,
            <>
                <Badge
                    theme={customer?.phoneNumber ? 'brand' : 'secondary'}
                    title={<><Icon icon={customer?.phoneNumber ? 'Phone' : 'XMark'} className="mr-2" /> SMS</>}
                    className="mr-4"
                />
                <Badge
                    theme={customer?.email ? 'brand' : 'secondary'}
                    title={<><Icon icon={customer?.email ? 'PaperPlane' : 'XMark'} className="mr-2" /> Email</>}
                />

            </>,
        ],
    ]} />
}

export default JobDetails;
